/* eslint-disable camelcase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { upperCase } from 'lodash';
import { history } from '../../../../store';
import Datatable from '../../../../components/common/datatable/index';
import Can from '../../../../components/common/guards/can';
import DeclineScanOverrideDialog from './decline-scan-override-dialog';
import { declineScanOverride } from '../../../../actions/scans';

class ScanOverridesTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDialogOpen: false,
      rowId: undefined
    };
  }

  handleOpenDialog = (rowId) => {
    this.setState({ isDialogOpen: true, rowId });
  }

  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false, rowId: undefined });
  }

  handleConfirmDialog = (result) => {
    if (result) {
      const { dispatch, decline_reason } = this.props;
      const { rowId } = this.state;

      dispatch(declineScanOverride(rowId, { decline_reason }));
      this.handleCloseDialog();
    } else {
      this.handleCloseDialog();
    }
  };

  render() {
    const {
      scans, currentPage, onPageChange, paging, onApprove
    } = this.props;
    const { isDialogOpen } = this.state;
    const dataToDisplay = (scans || []);
    const actions = [
      (index, row) => (
        <Row>
          <Col>
            <Can action='manage-scans' subjectClass='manage_scans'>
              <Button
                className="red-ghost-btn"
                onClick={() => onApprove(row.id)}
                disabled={row.attributes['override-request-status'] !== 'PENDING'}
              >Approve
              </Button>
            </Can>
          </Col>
          <Col>
            <Can action='manage-scans' subjectClass='manage_scans'>
              <Button
                className="red-ghost-btn"
                disabled={row.attributes['override-request-status'] !== 'PENDING'}
                onClick={() => {
                  this.handleOpenDialog(row.id);
                }}
              >
                Decline
              </Button>
            </Can>
          </Col>
        </Row>
      )
    ];

    const columns = [
      {
        prop: 'created-at',
        title: 'Request date'
      },
      {
        prop: 'customer-number',
        title: 'Customer number'
      },
      {
        prop: 'user-id',
        title: 'User ID',
        onClick: (cell, row) => {
          const userEditPath = row.attributes['is-owner-or-staff'] ? 'details' : 'edit';
          history.push(`/admin/users/${row.attributes['user-id']}/${userEditPath}`);
        }
      },
      {
        prop: 'product-code',
        title: 'Product code (EAN)',
        onClick: (cell, row) => {
          history.push(`/admin/products/${row.attributes['product-id']}`);
        }
      },
      {
        prop: 'outer-code',
        title: 'Outer Code'
      },
      {
        prop: 'override-request-status',
        title: 'Status',
        format: data => upperCase(data)
      },
      {
        title: 'Override image',
        format: (data, row) => {
          if (row.attributes['override-image-url']) {
            return (
              <Link target="_blank" to={row.attributes['override-image-url']}>
                {row.attributes['override-image-name']}
              </Link>
            );
          }
          return '';
        }
      }
    ];

    return (
      <div>
        <div className="mg-bottom-30">
        </div>
        <Datatable
          data={dataToDisplay}
          columns={columns}
          actions={actions}
          hideId={false}
          remote
          dataSize={paging ? paging.number * paging.size : dataToDisplay.length}
          pagination={{
            page: currentPage,
            sizePerPage: 20,
            onPageChange,
          }}
        />
        {isDialogOpen && (
          <DeclineScanOverrideDialog
            handleConfirmDialog={this.handleConfirmDialog}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  decline_reason: state.deep.forms.admin_decline_scan_orverride_dialog.decline_reason.value
});

export default connect(mapStateToProps)(ScanOverridesTable);



// WEBPACK FOOTER //
// ./src/components/admin/scans/scan-overrides/scan-overrides-table.jsx